import React, { createContext, useContext, useEffect, useState } from 'react';


//Helpers
import { getSessionCookie, setSessionCookie, removeAllCookies } from '../helpers/cookies';

function initialContext() {
    return {
        loading: false,
        isSignout: false,
        session: null
    }
}
export const AuthContext = createContext(initialContext());

const AuthProvider = ({ children }) => {
    //Estados de autenticação
    const [loading, setLoading] = useState(false);
    const [session, setSession] = useState(null);
    const [showNavigation, setShowNavigation] = useState(true);

    //Função que faz o controle de signIn
    const signIn = async (data) => {

        setLoading(false);
        setSessionCookie(data);
        setSession(data);
    }
    const signOut = async (token) => {
        if (!token)
            removeAllCookies();
        else {
            const usuario = await getSessionCookie();
            delete usuario.token;
            setSessionCookie(usuario);
        }
        setSession(null);
    }

    // Valida se o usuario ja esta logado e acessa direto o sistema
    useEffect(() => {
        const loadAsync = async () => {
            try {
                const data = await getSessionCookie();
                setSession(data);
                setLoading(false);
            } catch (e) {
            }
        };
        loadAsync();
    }, []);



    return (
        <AuthContext.Provider value={{
            loading,
            setLoading,
            session,
            signIn,
            signOut,
            showNavigation,
            setShowNavigation
        }}>

            {children}
        </AuthContext.Provider>
    );
}
export function useAuth() {
    const context = useContext(AuthContext)

    return context

}

export default AuthProvider;